import { Trans } from 'react-i18next'

import pelvicFloorPNG from '~/assets/images/anatomy/pelvic-floor.png'
import pelvicFloorWEBP from '~/assets/images/anatomy/pelvic-floor.webp'
import {
  ANSWERS,
  PELVIC_FLOOR_QUESTION,
  greenAccept,
  redCross,
} from '~/pages/anatomy/quizBinaryChoice/libs/constants'
import { Styles as S } from '~/pages/anatomy/quizBinaryChoice/libs/styles'
import { ImageLayoutStyles as PS } from '~/pages/anatomy/quizBinaryChoice/libs/styles/imageLayout'
import { useBinaryChoiceStep } from '~/shared/hooks/useBinaryChoiceStep'
import { TPageProps } from '~/shared/types/commonTypes'

const PelvicFloor = ({ nextPagePath, pageId }: TPageProps) => {
  const { answer, handleAnswer } = useBinaryChoiceStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: PELVIC_FLOOR_QUESTION,
  })

  return (
    <PS.Root>
      <PS.StyledContainer>
        <PS.Question>
          <Trans ns="anatomy" i18nKey="onboarding.pelvicFloor.question" />
        </PS.Question>

        <PS.ImageWrapper>
          <picture>
            <source srcSet={pelvicFloorWEBP} type="image/webp" />
            <img src={pelvicFloorPNG} alt="Pelvic floor" />
          </picture>
        </PS.ImageWrapper>

        <PS.ButtonWrapper>
          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.no}
            onClick={() => handleAnswer(ANSWERS.no)}
          >
            <S.ButtonIcon src={redCross} alt={ANSWERS.no} />

            <Trans i18nKey={`actions.${ANSWERS.no}`} />
          </S.StyledButton>

          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.yes}
            onClick={() => handleAnswer(ANSWERS.yes)}
          >
            <S.ButtonIcon src={greenAccept} alt={ANSWERS.yes} />

            <Trans i18nKey={`actions.${ANSWERS.yes}`} />
          </S.StyledButton>
        </PS.ButtonWrapper>
      </PS.StyledContainer>
    </PS.Root>
  )
}

export default PelvicFloor
